import React from 'react';

const DefaultRootBody = ({ children }) => (
  <div className="default-type-root-body">{children}</div>
);

export default DefaultRootBody;
